const intructors = [
    {
        id: 1,
        classnames: 'team-member border-ra4',
        src: 'images/instructors/instructor-1.jpg',
        name: 'Aleksejs Petenko',
        position: 'Teacher',
        description: 'Lobortis arcu, a vestibulum augue. Vivamus ipsum neque, facilisis vel mollis vitae.',
        classicon: 'socails flat-text-center'
    },
    {
        id: 2,
        classnames: 'team-member border-ra4  border-f-e6f3ff',
        src: 'images/instructors/instructor-2.jpg',
        name: 'Anna Kunytska',
        position: 'Teacher',
        description: 'Lobortis arcu, a vestibulum augue. Vivamus ipsum neque, facilisis vel mollis vitae.',
        classicon: 'socails flat-text-center'
    },
    {
        id: 3,
        classnames: 'team-member border-ra4  border-f-e6f3ff',
        src: 'images/instructors/instructor-3.jpg',
        name: 'Ben Daniel',
        position: 'Teacher',
        description: 'Lobortis arcu, a vestibulum augue. Vivamus ipsum neque, facilisis vel mollis vitae.',
        classicon: 'socails flat-text-center'
    }

]

export default intructors;